document.body.classList.add('my-popup');

function cartPopupUpdate(){
   fetch('/cart.js', {
      method: 'GET',
     headers: {
        'Content-Type': 'application/json'
      },
  })
.then(response => {
      return response.json()
  })
.then((cart)=>{
    var lineItems = []
      document.querySelector('.mini-products-list').innerHTML = ''
       var cartCounter = cart.item_count;
       console.log(cartCounter, 'cartCounter')
       document.querySelector('.cart-counter').innerText = cartCounter;
if (window.innerWidth < 767 && document.body.classList.contains('no-index')) {
    document.querySelector('.bottom-cart-count').innerText = cartCounter;
}
  console.log(cartCounter, 'cartcount')
       var totalPrice = priceFormatting(cart.total_price / 100);
      console.log(totalPrice,'totalprice')
      cart.items.forEach((item, i) => {
          var perItemPrice = priceFormatting(item.original_price / 100) ;
          var itemPrice = priceFormatting(item.original_price  * item.quantity / 100) ;
          var salePrice = priceFormatting(item.final_price  * item.quantity / 100) ;
          var displayPrice = item.final_price < item.original_price ? salePrice : itemPrice;
         var variantOptions = '';
  if (item.options_with_values.length > 0) {
    item.options_with_values.forEach(option => {
        variantOptions += `<small>${option.name}: ${option.value}</small><br>`;
    });
}
          var lineItemDetails = `<li class="item" data-id="${item.id}" data-line="${i+1}">
              <a href="${item.url}" class="product-image">
              <img loading="lazy" src="${item.image}" alt="${item.title}">
              </a>
              <div class="product-details" data-line-item-key="${ item.key }">
              <a class="product-name" href="${item.url}">${item.product_title}</a>
              <div class="item-price">Rs.${perItemPrice}</div>
              <div class="option">
              ${variantOptions}
              </div>
              <div class="cart-collateral">
                  <span class="price">
                  <span class="money orignal-price">Rs ${displayPrice}</span>
                  </span>
              </div>
              <div class="quantities popup-quantity">
              <div class="cart-quantity">
              <quantity-input class="quantity cart-quantity drawer-quantity">
              <button class="quantity__button popup-qty-btn quantity__button-minus" name='minus' type="button">
              <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              class="icon icon-minus"
              fill="none"
              viewBox="0 0 10 2"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
            </svg>
            </button>
              <input class="quantity__input popup-quantity-input" type="number" value="${item.quantity}" data-quantity-variant-id="${ item.id }" data-index="${i+1}" data-price="${item.price}"  min="1" readonly>
              <button class="quantity__button popup-qty-btn quantity__button-plus" name='plus'  type="button">
              <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              class="icon icon-plus"
              fill="none"
              viewBox="0 0 10 10"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
            </svg>
            
             </button>
              </quantity-input>
              <div class="drawer-error"></div>
              </div>
              <a href="javascript:void(0)" title="Remove" class="btn-remove">
                               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
</svg>
              </a>
              </div>
              
              </div>
          </li>`
          lineItems.push(lineItemDetails) 
          console.log(lineItems)   
      })
       document.querySelector('.mini-products-list').innerHTML = lineItems.join('')
       document.querySelector('.total .price').innerText = `Rs ${totalPrice}`
       if(cartCounter > 0){
          document.querySelector('.cart-count-bubble').classList.remove('hidden')
         if (window.innerWidth < 767 && document.body.classList.contains('no-index')) {
    document.querySelector('.bottom-cart-count').classList.remove('hidden')
}
          document.querySelector('#dropdown-cart .has-items').classList.remove('hidden')
          document.querySelector('#dropdown-cart .no-items').classList.add('hidden')
      }else{
          document.querySelector('.cart-count-bubble').classList.add('hidden')
         if (window.innerWidth < 767 && document.body.classList.contains('no-index')) {
    document.querySelector('.bottom-cart-count').classList.add('hidden')
}
          document.querySelector('#dropdown-cart .has-items').classList.add('hidden')
          document.querySelector('#dropdown-cart .no-items').classList.remove('hidden')
      }
})
.catch((error) => {
      body.classList.add('cart-error-active')
          document.querySelector('#cart-error-popup').innerText = 'error'
          setTimeout(()=> {
              body.classList.remove('cart-error-active')
      },3000)
  })
.finally(() => {
       removeCartItem();
        updateqty()
  updateCart()
  document.querySelector('#dropdown-cart').style.transform = 'translateX(0%)'
  })
}
document.querySelector('#dropdown-shadow').addEventListener('click', (e)=> {
  e.preventDefault()
  document.querySelector('#dropdown-cart').style.transform = 'translateX(100%)'
  if(body.classList.contains('cart-popup-active')){
      body.classList.remove('cart-popup-active')
  }

  body.classList.remove('dropdown-shadow')
})
document.querySelector('.drawer-close-btn').addEventListener('click', (e)=> {
  e.preventDefault()
  document.querySelector('#dropdown-cart').style.transform = 'translateX(100%)'
  if(body.classList.contains('cart-popup-active')){
      body.classList.remove('cart-popup-active')
  }

  body.classList.remove('dropdown-shadow')
})
                   
document.querySelector('.header__icon--cart').addEventListener("click", function(){
  document.querySelector('#dropdown-cart').style.transform = 'translateX(0%)'
      body.classList.add('cart-popup-active')
      body.classList.add('dropdown-shadow')
})




function sizeAddTocart(){
var btn1 = document.querySelectorAll('.quick-cart-add ul li:not(.sold_out)')
btn1.forEach(item1 => {
  item1.addEventListener('click', ()=> {
       var variantId1 = item1.getAttribute('data-id')
       
      item1.closest('.card-wrapper').classList.add('size-selected')
      item1.closest('.card-wrapper').setAttribute('data-variant-id', variantId1)
      
           var formData = {
           'items': [{
          'id': variantId1,
            'quantity': 1
            }]
           }
          fetch('/cart/add.js', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json'
             },
             body: JSON.stringify(formData) 
           })
           .then(response => {
             return response.json()
           })
          .then((data)=>{
             if (data.status === 422){
               body.classList.add('cart-error-active')
               document.querySelector('#cart-error-popup').innerText = data.description
               setTimeout(()=> {
                   body.classList.remove('cart-error-active')
              },3000)
             }
             else{
              // if(window.innerWidth > 767){
               cartPopupUpdate()
               setTimeout(()=> {
                 body.classList.add('cart-popup-active')
                   body.classList.add('dropdown-shadow') 
               },500)
              // }else{
              //   window.location = window.routes.cart_url;
              //   cartPopupUpdate()
              // }
            }
           })
        .catch((error) => {
              body.classList.add('cart-error-active')
              document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
              setTimeout(()=> {
                  body.classList.remove('cart-error-active')
              },3000)
          })
         .finally(() => {
          })
      
    setTimeout(()=>{
          item1.closest('.quick-cart-add').classList.remove('active')
          item1.closest('.card-wrapper').style.display = 'block'
          body.classList.remove('dropdown-shadow')
      },200)
  });
});
}
sizeAddTocart();

function removeCartItem(){
//     // Remove from cart
  var btn = document.querySelectorAll('.btn-remove')
   btn.forEach(item => {
     item.addEventListener('click', (e)=> {
      e.preventDefault()
       var lineId = item.closest('.item').getAttribute('data-line')
      var formData = {
          'line': lineId,
          'quantity': 0
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json()
      })
      .then((data)=>{
        if (data.status === 422){
        }
        else{
          cartPopupUpdate()
        }
      })
      .catch((error) => {
          body.classList.add('cart-error-active')
          document.querySelector('#cart-error-popup').innerText = 'An Error Occured. Please try again later'
          setTimeout(()=> {
              body.classList.remove('cart-error-active')
          },3000)
      })
    })
  })
}
removeCartItem()



function updateqty(){
  document.querySelectorAll('.popup-qty-btn').forEach(popupQtyBtn => {
    popupQtyBtn.addEventListener("click", (e)=> {
        e.preventDefault()
        var parentitem = popupQtyBtn.closest('.item');
        console.log(parentitem )
        var key = popupQtyBtn.closest('.item').getAttribute('data-id')
        const currentqtyValue = parseInt(popupQtyBtn.parentElement.querySelector("input").value);
        console.log( currentqtyValue)
        const isUp = popupQtyBtn.classList.contains('quantity__button-plus');

        let newQuantity = isUp ? parseInt(currentqtyValue) : parseInt(currentqtyValue) ;
        console.log(newQuantity);
        

        var formData = {
          'id': key,
          'quantity': newQuantity
      }
       fetch('/cart/change.js', {
          method: 'POST',
         headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData) 
      })

      .then(response => {
        return response.json()
      })
      .then((data)=>{
        if (data.status === 422) {
          parentitem.querySelector('.drawer-error').innerText = `You can't add more this product to cart`;
          setTimeout(() => {
              // After 2 seconds, execute the cartPopupUpdate() function
              cartPopupUpdate();
            console.log('error function meh')
          }, 1600); // 2000 milliseconds = 2 seconds
      } else {
          cartPopupUpdate();
      }
       })
    
      .catch(error => {
      })

    });
  });
}
updateqty()



 const progressBar = document.querySelector('.progress-bar-done');
  const freeShippingNotice = document.querySelector('.free_shipping_notice');
  const freeShippingIcon = document.querySelector('.free-shipping-icon');

  function updateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const shippingValue = shippingValueDynamic;
        const cartTotal = cart.item_count;
        const shippingValueLeft = shippingValue - cartTotal;
        const shippingPercentageFraction = (cartTotal / shippingValue) * 100;

        progressBar.style.width = `${shippingPercentageFraction}%`;

        if (shippingValueLeft > 0 && shippingValueLeft < shippingValue ) {
          freeShippingNotice.textContent = `Add ${shippingValueLeft} more item${shippingValueLeft > 1 ? 's' : ''} to get Free Delivery!`;
          freeShippingIcon.classList.remove('iconicion');
          console.log('add more');
        } else {
          freeShippingNotice.textContent = 'You have Free Delivery!!!';
          freeShippingIcon.classList.add('iconicion');
          console.log('free');
        }
      });
  }
updateCart()